function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var EcuadorFlag = props => /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
  width: "1em",
  height: "1em",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), {}, {
  children: [/*#__PURE__*/_jsx("mask", {
    id: "mask0_621_4228",
    style: {
      maskType: 'luminance'
    },
    maskUnits: "userSpaceOnUse",
    x: "0",
    y: "3",
    width: "24",
    height: "18",
    children: /*#__PURE__*/_jsx("rect", {
      y: "3",
      width: "24",
      height: "18",
      fill: "white"
    })
  }), /*#__PURE__*/_jsxs("g", {
    mask: "url(#mask0_621_4228)",
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 3V21H24V3H0Z",
      fill: "#2E42A5"
    }), /*#__PURE__*/_jsx("mask", {
      id: "mask1_621_4228",
      style: {
        maskType: 'luminance'
      },
      maskUnits: "userSpaceOnUse",
      x: "0",
      y: "3",
      width: "24",
      height: "18",
      children: /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 3V21H24V3H0Z",
        fill: "white"
      })
    }), /*#__PURE__*/_jsxs("g", {
      mask: "url(#mask1_621_4228)",
      children: [/*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 3V12H24V3H0Z",
        fill: "#FECA00"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 16.5V21H24V16.5H0Z",
        fill: "#E31D1C"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6.90957 7.34395C6.81926 7.14025 10.2925 6.10946 10.5528 6.10946C10.813 6.10946 11.1422 6.72671 11.1422 6.72671L13.2545 6.89757C13.2545 6.89757 13.005 6.10946 13.2545 6.10946C13.504 6.10946 17.3282 7.43783 17.3282 7.43783C17.3282 7.43783 12.5476 8.01409 12.5476 8.14384C12.5476 8.27359 12.8608 8.98591 12.8608 8.98591L11.9767 9.2756C11.9767 9.2756 12.0286 8.41717 11.8845 8.41717C11.7403 8.41717 11.3124 9.4439 11.3124 9.4439L10.8928 8.14384C10.8928 8.14384 6.99988 7.54765 6.90957 7.34395Z",
        fill: "#7B2900"
      }), /*#__PURE__*/_jsx("path", {
        d: "M6.9245 10.5135L7.87006 10.7396C6.88074 14.8768 7.79517 16.8609 10.6109 17.0453L10.5474 18.0154C7.01877 17.7844 5.81197 15.1659 6.9245 10.5135Z",
        fill: "#FECA00"
      }), /*#__PURE__*/_jsx("path", {
        d: "M7.50037 9.95578L8.4609 10.1061C7.78338 14.4356 8.32596 16.3933 9.84671 16.3397L9.88093 17.3114C7.45129 17.3969 6.73841 14.8248 7.50037 9.95578Z",
        fill: "#07138E"
      }), /*#__PURE__*/_jsx("path", {
        d: "M8.47253 9.55872L9.43307 9.70903C8.75554 14.0386 9.29813 15.9962 10.8189 15.9427L10.8531 16.9143C8.42345 16.9999 7.71058 14.4278 8.47253 9.55872Z",
        fill: "#E10001"
      }), /*#__PURE__*/_jsx("path", {
        d: "M10.2766 17.4551L11.2443 17.361C11.3239 18.1803 11.2636 18.8867 11.056 19.4799L10.1384 19.1588C10.295 18.7111 10.3435 18.1433 10.2766 17.4551Z",
        fill: "#07138E"
      }), /*#__PURE__*/_jsx("path", {
        d: "M16.1249 10.6265C16.1249 10.6265 17.6745 17.5961 12.8996 17.4755",
        stroke: "#FECA00",
        strokeWidth: "0.648148"
      }), /*#__PURE__*/_jsx("path", {
        d: "M16.0219 9.95578L15.0613 10.1061C15.7388 14.4356 15.1963 16.3933 13.6755 16.3397L13.6413 17.3114C16.0709 17.3969 16.7838 14.8248 16.0219 9.95578Z",
        fill: "#07138E"
      }), /*#__PURE__*/_jsx("path", {
        d: "M15.0496 9.55872L14.0891 9.70903C14.7666 14.0386 14.224 15.9962 12.7033 15.9427L12.6691 16.9143C15.0987 16.9999 15.8116 14.4278 15.0496 9.55872Z",
        fill: "#E10001"
      }), /*#__PURE__*/_jsx("path", {
        d: "M13.0564 17.4605L12.0899 17.3556C12.0087 18.1038 12.0705 18.7519 12.2836 19.2977L13.1892 18.944C13.0381 18.557 12.991 18.0632 13.0564 17.4605Z",
        fill: "#07138E"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10.4 16.125H13.3166V17.5147H10.4V16.125Z",
        fill: "#908F89"
      }), /*#__PURE__*/_jsx("path", {
        d: "M11.8583 16.375C12.6302 16.375 13.3063 15.9401 13.7798 15.2826C14.2536 14.6247 14.5388 13.7285 14.5388 12.75C14.5388 11.7715 14.2536 10.8753 13.7798 10.2174C13.3063 9.55994 12.6302 9.125 11.8583 9.125C11.0863 9.125 10.4103 9.55994 9.93676 10.2174C9.463 10.8753 9.17773 11.7715 9.17773 12.75C9.17773 13.7285 9.463 14.6247 9.93676 15.2826C10.4103 15.9401 11.0863 16.375 11.8583 16.375Z",
        stroke: "#FEE901",
        strokeWidth: "0.5"
      }), /*#__PURE__*/_jsx("mask", {
        id: "mask2_621_4228",
        style: {
          maskType: 'luminance'
        },
        maskUnits: "userSpaceOnUse",
        x: "8",
        y: "8",
        width: "7",
        height: "9",
        children: /*#__PURE__*/_jsx("path", {
          d: "M11.8583 16.375C12.6302 16.375 13.3063 15.9401 13.7798 15.2826C14.2536 14.6247 14.5388 13.7285 14.5388 12.75C14.5388 11.7715 14.2536 10.8753 13.7798 10.2174C13.3063 9.55994 12.6302 9.125 11.8583 9.125C11.0863 9.125 10.4103 9.55994 9.93676 10.2174C9.463 10.8753 9.17773 11.7715 9.17773 12.75C9.17773 13.7285 9.463 14.6247 9.93676 15.2826C10.4103 15.9401 11.0863 16.375 11.8583 16.375Z",
          fill: "white",
          stroke: "white",
          strokeWidth: "0.5"
        })
      }), /*#__PURE__*/_jsxs("g", {
        mask: "url(#mask2_621_4228)",
        children: [/*#__PURE__*/_jsx("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M13.6186 14.5538C13.6186 14.5538 12.437 13.9108 12.0978 13.6816C11.7587 13.4524 11.9545 12.941 11.3704 13.0777C10.7863 13.2144 10.3171 13.4524 10.3171 14.1049C10.3171 14.7573 9.85848 15.1447 9.7022 14.6989C9.54591 14.2531 8.81102 12.1685 9.7022 12.1685C10.5934 12.1685 12.6765 12.636 13.2897 12.636C13.9028 12.636 14.2598 12.9542 14.2598 13.5295C14.2598 14.3034 13.6186 14.5538 13.6186 14.5538Z",
          fill: "#8DDD61"
        }), /*#__PURE__*/_jsx("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M11.8583 11.1618C12.1268 11.1618 12.3444 10.9396 12.3444 10.6654C12.3444 10.3913 12.1268 10.1691 11.8583 10.1691C11.5898 10.1691 11.3722 10.3913 11.3722 10.6654C11.3722 10.9396 11.5898 11.1618 11.8583 11.1618Z",
          fill: "#FEE901"
        }), /*#__PURE__*/_jsx("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M10.2521 11.2054C10.2521 11.2054 10.8175 11.0686 11.5989 11.5952C12.3802 12.1217 14.2746 12.4215 14.2746 12.0083C14.2746 11.5952 14.2746 12.8132 14.2746 12.8132C14.2746 12.8132 10.0712 12.5515 9.8463 12.8132C9.62142 13.0749 9.59898 11.3517 9.8463 11.2054C10.0936 11.0591 10.2521 11.2054 10.2521 11.2054Z",
          fill: "#F7FCFF"
        })]
      })]
    })]
  })]
}));
//# sourceMappingURL=Ecuador.js.map